import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { filter, reject } from 'lodash'

import { Errors, Error } from '../../types/common'

export interface FormError {
  [formName: string]: string[]
}

interface ErrorsState {
  alertErrors: Error[]
  formErrors: FormError
  needResetToken: boolean
}

const initialState: ErrorsState = {
  alertErrors: [],
  formErrors: {},
  needResetToken: false,
}

const errorsSlice = createSlice({
  name: 'errors',
  initialState,
  reducers: {
    setErrors: (state: ErrorsState, action: PayloadAction<Errors>) => {
      state.alertErrors = [...state.alertErrors, ...reject(action.payload.errors, 'column_name')]
      const formErrors = filter(action.payload.errors, 'column_name')
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      state.formErrors = formErrors.reduce((r: FormError, formError) => ({ ...r, [formError.column_name!]: formError.message }), {})
      state.needResetToken = action.payload.needResetToken
      return state
    },
    removeAlertError: (state: ErrorsState) => {
      state.alertErrors = []
      return state
    },
    resetFormErrors: (state: ErrorsState) => {
      state.formErrors = {}
      return state
    },
    resetNeedResetToken: (state: ErrorsState) => {
      state.needResetToken = false
      return state
    },
  },
})

export const {
  setErrors,
  removeAlertError,
  resetFormErrors,
  resetNeedResetToken,
} = errorsSlice.actions

export const errorsReducer = errorsSlice.reducer
